import { render, staticRenderFns } from "./AutoReadDlg.vue?vue&type=template&id=67ba77d4&scoped=true"
import script from "./AutoReadDlg.vue?vue&type=script&lang=js"
export * from "./AutoReadDlg.vue?vue&type=script&lang=js"
import style0 from "./AutoReadDlg.vue?vue&type=style&index=0&id=67ba77d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba77d4",
  null
  
)

export default component.exports